import React from 'react';

// Filet de sécurité pour de vrais utilisateurs pendant le pilote : si un
// composant plante au rendu, on affiche un écran de secours au lieu d'un
// écran blanc ou d'une pile d'erreurs technique. React exige une classe ici
// (pas d'équivalent hook à ce jour pour getDerivedStateFromError).
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Erreur applicative interceptée par ErrorBoundary :', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.href = '/';
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 14, background: '#070D1E', color: '#EAF0FA', fontFamily: "'DM Sans',sans-serif", padding: 24, textAlign: 'center' }}>
        <div style={{ fontSize: 17, fontWeight: 800 }}>Une erreur est survenue</div>
        <div style={{ fontSize: 13, color: '#8794ab', maxWidth: 360 }}>
          Quelque chose s'est mal passé. Vous pouvez réessayer — vos informations de connexion sont conservées.
        </div>
        <button
          onClick={this.handleReload}
          style={{ marginTop: 6, background: '#002D96', color: '#fff', border: 'none', borderRadius: 10, padding: '10px 20px', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}
        >
          Revenir à l'accueil
        </button>
      </div>
    );
  }
}
